<template>
  <div>
    <div v-show="qpStatus == ''">
      <div v-show="step == 'option' && !callback && !invoiceCall">
        <d-row>
          <d-col>
            <h6 class="title">Та төлбөрийн сонголт сонгоно уу</h6>
          </d-col>
        </d-row>
        <d-row>
          <d-form-select
            size="sm"
            value-field="id"
            text-field="name"
            v-model="selected"
            :options="optionList"
            @change="next('main')"
          >
            <option :value="null">Төлбөрийн сонголт</option>
          </d-form-select>
        </d-row>
      </div>
      <div v-show="step == 'main' && !callback">
        <d-row>
          <d-col>
            <h6 class="title">Та төлбөрийн хувилбараа сонгоно уу</h6>
          </d-col>
        </d-row>
        <d-row class="blocks">
          <d-col>
            <d-badge outline theme="info">QPAY</d-badge>
          </d-col>
          <d-col>
            <d-badge outline theme="info">КАРТААР</d-badge>
          </d-col>
          <d-col>
            <d-badge outline theme="info">SOCIALPAY</d-badge>
          </d-col>
        </d-row>
        <d-row class="blocks">
          <d-col>
            <d-button outline theme="info" id="qpay" @click="next('qpay')"
              ><img src="../../assets/img/icon/Q-pay.png"
            /></d-button>
          </d-col>
          <d-col>
            <d-button
              outline
              theme="info"
              id="ecommerce"
              @click="next('ecommerce')"
              ><img src="../../assets/img/icon/E-commerce.png"
            /></d-button>
          </d-col>
          <d-col>
            <d-button
              outline
              theme="info"
              id="socialpay"
              @click="next('socialpay')"
              ><img src="../../assets/img/icon/Social-Pay.png"
            /></d-button>
          </d-col>
        </d-row>
      </div>
      <div v-show="step == 'qpay'">
        <d-row>
          <d-col lg="12" md="12" sm="12">
            <h6 class="title">{{ qpayTitle }}</h6>
          </d-col>
          <d-col lg="6" md="6" sm="12">
            <img :src="getImgUrl()" />
          </d-col>
          <d-col lg="6" md="6" sm="12">
            <br />
            <ul>
              <li>- Хаан банк</li>
              <li>- Худалдаа хөгжлийн банк</li>
              <li>- Төрийн банк</li>
              <li>- Хас банк</li>
              <li>- Капитрон банк</li>
              <li>- Богд банк</li>
            </ul>
          </d-col>
        </d-row>
      </div>
      <div v-show="callback">
        <d-row>
          <d-col align="center">
            <img
              src="../../assets/img/icon/success.png"
              v-if="status == 'success'"
            />
            <img src="../../assets/img/icon/fail.png" v-if="status == 'fail'" />
          </d-col>
        </d-row>
      </div>
      <div v-show="step == 'account'">
        <div>
          <p><strong>Данс эзэмшигчийн нэр:</strong></p>
          <ul>
            <li>Исатком ХХК, Isatcom LLC</li>
          </ul>
          <p><strong>Банкны данс:</strong></p>
          <ul>
            <li>Хаан банк - 109 0000 20012 / төгрөгийн данс /</li>
            <li>Төрийн банк - 5124023523 / төгрөгийн данс /</li>
          </ul>
          <p><strong>Гүйлгээний утга:</strong></p>
          <ul>
            <li>
              Регисртийн дугаар / Гэрээ байгуулсан компаний РД, хувь хүн бол
              гэрээ байгуулсан хүний РД /
            </li>
            <li>РД нь латин, крилл үсгээр бичих боломжтой байх</li>
          </ul>
          <p><strong>Санамж:</strong></p>
          <ul>
            <li>
              Төлбөр илүү шилжүүлсэн тохиолдолд дараа сарын төлбөрөөс
              суутгагдана./илүү төлөлттэй харагдана/
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-show="qpStatus == 'success' || qpStatus == 'fail'">
      <d-row>
        <d-col align="center">
          <img
            src="../../assets/img/icon/success.png"
            v-show="qpStatus == 'success'"
          />
          <img
            src="../../assets/img/icon/fail.png"
            v-show="qpStatus == 'fail'"
          />
        </d-col>
      </d-row>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  created() {
    if (this.invoiceCall) this.step = "main";

    this.status = "success";
    var tmplist = [];
    var list = this.options;
    var i = 0;
    for (i = 0; i < list.length; i++) {
      var data = {};
      data.id = list[i].Id;
      data.amount = list[i].Amount;
      if (
        this.btnString != null &&
        this.btnString == "Дата" &&
        list[i].Type == 5
      ) {
        data.name = "Дата " + list[i].Amount + "₮";
        tmplist.push(data);
      } else if (
        this.btnString != null &&
        this.btnString == "Яриа" &&
        list[i].Type == 4
      ) {
        data.name = "Яриа " + list[i].Amount + "₮";
        tmplist.push(data);
      }
    }

    this.optionList = tmplist;

    //status with params or not
    if (this.$router.history.current.query.id != null) {
      var tranId = this.$router.history.current.query.id;
      const tranconfig = {
        method: "post",
        url:
          "https://www.mongolsat.mn/isat/contract/invoice/check?id=" +
          tranId +
          "",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.$store.getters.userToken,
        },
      };
      //transaction check by id
      axios(tranconfig).then(
        (response) => {
          if (response.data.code == 0 && response.data.object == true) {
            this.status = "success";
            var configData = {
              method: "post",
              url: "https://mongolsat.mn/isat/contract/data",
              headers: {
                Authorization: "Bearer " + this.$store.getters.userToken,
              },
            };
            var configPayment = {
              method: "get",
              url: "https://mongolsat.mn/isat/contract/payments?page=1",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + this.$store.getters.userToken,
              },
            };
            var configPhone = {
              method: "post",
              url: "https://www.mongolsat.mn/isat/contract/phones",
              headers: {
                Authorization: "Bearer " + this.$store.getters.userToken,
              },
            };

            const requestOne = axios(configData);
            const requestTwo = axios(configPayment);
            const requestThirth = axios(configPhone);

            axios.all([requestOne, requestTwo, requestThirth]).then(
              axios.spread((...responses) => {
                const responseOne = responses[0];
                const responseTwo = responses[1];
                const responseThirth = responses[2];

                if (
                  responseOne.data.code == 0 &&
                  responseOne.data.object != null
                ) {
                  this.$store.dispatch("retrieveAddData", {
                    addData: responseOne.data.object.topupQuota,
                  });
                  this.$store.dispatch("retrieveRemainData", {
                    remainData: responseOne.data.object.remainingQuota,
                  });
                }
                if (responseTwo.data != null && responseTwo.data.length > 0) {
                  this.$store.dispatch("retrievePayments", {
                    payments: responseTwo.data,
                  });
                }
                if (
                  responseThirth.data.code == 0 &&
                  responseThirth.data.object != null
                ) {
                  var tmpPhoneList = [];
                  var i = 0;

                  for (i = 0; i < responseThirth.data.object.length; i++) {
                    var data = {};
                    (data.id = i),
                      (data.name = responseThirth.data.object[i].name),
                      (data.phone = responseThirth.data.object[i].phone),
                      (data.balance =
                        responseThirth.data.object[i].balance < 1
                          ? 0
                          : responseThirth.data.object[i].balance),
                      tmpPhoneList.push(data);
                  }
                  this.$store.dispatch("retrievePhoneData", {
                    phoneData: tmpPhoneList,
                  });

                  this.$store.dispatch("retrieveSelected", {
                    selected: tmpPhoneList[0],
                  });
                  
                  this.$store.dispatch("retrieveBalance", {
                    balance:
                      responseThirth.data.object[this.index].balance < 1
                        ? 0
                        : responseThirth.data.object[this.index].balance,
                  });
                }
              }),
              (error) => {
                console.log(error);
              }
            );
          } else this.status = "fail";

          console.log(this.status);
        },
        (error) => {
          console.log(error);
        }
      );
    }
  },
  data() {
    return {
      step: "option",
      qrcode: "",
      status: "",
      qpayTitle: "",
      optionList: [],
      selected: null,
      openModal: false,
    };
  },
  methods: {
    getImgUrl() {
      var qrcodestring = "data:image/png;base64," + this.qrcode;
      return qrcodestring;
    },
    async next(prop) {
      this.step = prop;
      this.qpayTitle = this.btnString + " QR code";

      if (prop == "ecommerce" || prop == "socialpay") {
        this.$emit("clicked", false);

        var config = null;
        if (this.invoiceCall)
          config = {
            method: "post",
            url: "https://mongolsat.mn/isat/contract/invoice/golomt",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.$store.getters.userToken,
            },
            data: JSON.stringify({
              InvoiceId: this.invoiceId,
              InvoiceAmount: this.invoiceAmount,
            }),
          };
        else
          config = {
            method: "post",
            url: "https://mongolsat.mn/isat/contract/service/golomt",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.$store.getters.userToken,
            },
            data: JSON.stringify({ ServiceId: this.selected + "" }),
          };

        await axios(config)
          .then((response) => {
            var invoiceId = response.data.object.invoice;

            if (prop == "socialpay") {
              window.open(
                "https://ecommerce.golomtbank.com/socialpay/mn/" + invoiceId
              );
            } else {
              window.open(
                "https://ecommerce.golomtbank.com/payment/mn/" + invoiceId
              );
            }
          })
          .catch((error) => console.log(error.response));
      } else if (prop == "qpay") {
        var qpConfig = null;
        if (this.invoiceCall)
          qpConfig = {
            method: "post",
            url: "https://mongolsat.mn/isat/contract/invoice/qpay",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.$store.getters.userToken,
            },
            data: JSON.stringify({
              serviceId: "",
              invoiceId: this.invoiceId,
              invoiceAmount: this.invoiceAmount,
            }),
          };
        else
          qpConfig = {
            method: "post",
            url: "https://mongolsat.mn/isat/contract/service/qpay",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.$store.getters.userToken,
            },
            data: JSON.stringify({
              serviceId: this.selected + "",
              description:  this.selectedOption != null ?  this.selectedOption.phone + "" : "",
            }),
          };

        axios(qpConfig)
          .then((response) => {
            if (response.data.code == 0) {
              if (this.$device.mobile){
                this.$emit("clicked", false);
                window.open(response.data.object.qPay_shortUrl);              
              }            
               else {
                this.qrcode = response.data.object.qr_image;
                this.$emit("clicked", response.data.object.transactionId);
              }
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
  },
  computed: {
    retrieveUniqueId: function () {
      //generate auto unique id
      return this.uid;
    },
    selectedOption() {
      return this.$store.getters.selected;
    },
    options() {
      return this.$store.getters.options;
    },
  },
  props: {
    invoiceCall: Boolean,
    callback: Boolean,
    btnString: String,
    qpStatus: String,
    invoiceId: String,
    invoiceAmount: Number,
  },
};
</script>
<style lang="scss" scoped>
.title {
  text-align: center;
}
.qpay {
  padding-left: 15px;
}
.blocks {
  padding: 10px;
}
</style>